import { Layout } from "../../components/Layout";
import { MsgProvider } from "../../components/Msg";
import { useMsg } from "../../components/Msg/Msg";
import { UserProfileSettings } from "./UserProfileSettings";
import { settingsMessages } from "./messages";

export function UserProfilePage() {
  const msg = useMsg({ dict: settingsMessages });

  return (
    <MsgProvider messages={settingsMessages}>
      <Layout header={{ heading: msg("settings.user-profile.heading") }}>
        <UserProfileSettings />
      </Layout>
    </MsgProvider>
  );
}
